const Constants = Object.freeze({
  // ---------------------------- Backend IP ----------------------------
  MONITOR_REQUEST_IP_ADDRESS: `${window.location.origin}${process.env.PUBLIC_URL}/api/`,

  LOCAL_STORAGE_KEY: "mn-dn-language",
  ES_LANG_KEY: "es",
  EN_LANG_KEY: "en",
  PT_LANG_KEY: "pt",

  // ---------------------------- Page Scaling Modifiers ----------------------------
  SCALING_FACTOR_LIVE_TOPOLOGY: 0.62,
  SCALING_FACTOR_LIVE_TOPOLOGY_DP: 0.60,
  SCALING_FACTOR_LOG: 0.54,

  // ###################################################################
  // ########################### TS EXPERT #############################
  // ###################################################################

  // --------------------- MISC. ---------------------------
  NONE: "None",
  LOADING_IMG: "loading-img",

  // --------------------- PROTOCOL ERROR TYPES ---------------------------
  RETRIES_ERROR_TYPE: "retries",
  RETRIES_UPDATE_ERROR_TYPE: "retriesUpdate",
  DIAGNOSTIC_ERROR_TYPE: "diagnostic",
  DIAGNOSTIC_UPDATE_ERROR_TYPE: "diagnosticUpdate",
  FAULT_ERROR_TYPE: "fault",
  FAULT_UPDATE_ERROR_TYPE: "faultUpdate",
  ERROR_FRAME_TYPE: "errorFrame",
  ERROR_FRAME_UPDATE_TYPE: "errorFrameUpdate",
  MISSING_ERROR_TYPE: "missing",
  MISSING_UPDATE_ERROR_TYPE: "missingUpdate",

  // ------------------- ANALYZER DN ERROR TYPES -------------------------
  BAD_SIGNAL_PROBLEM_TYPE: "badSignal",
  ATTENTION_SIGNAL_PROBLEM_TYPE: "attentionSignal",
  CAPACITIVE_EFFECT_PROBLEM_TYPE: "capacitiveEffect",
  NOISE_PROBLEM_TYPE: "noise",

  // ###################################################################
  // ########################### CONFIG ##############################
  // ###################################################################

  // ---------------------------- Configuration page related ----------------------------
  AUTH_STR: "f4610aa514477222afac2b77f971d069780ca2846f375849f3dfa3c0047ebbd1",
  GPG_FILE_EXTENSION: ".gpg",

  NOT_UPDATING: "notUpdating",
  UPDATE_FILES_FOUND: "updateFilesFound",
  FINISHED_UPDATING: "finishedUpdating",
  RESTARTING_MONITOR: "restartingMonitor",
  UPDATE_IDLE_SIZE: "updatingIdleSize",
  UPDATE_PACKET_SIZE: "updatingPacketSize",

  FILE_UPDATE_TYPE: "file-update",
  NTP_UPDATE_TYPE: "turnNtpOn",

  // ------------------------------- NTP UPDATE STATUS ----------------------------
  NTP_UPDATE_NOT_STARTED: "notUpdating",
  NTP_UPDATE_START: "start",
  NTP_UPDATE_SUCCESS: "sucess",
  NTP_UPDATE_FAIL: "fail",

  // ---------------------------- WLAN Config ----------------------------
  CONNECTED_STATUS: "connected",
  DISCONNECTED_STATUS: "disconnected",

  DHCP_MODE: "dhcp",
  FIXED_IP_MODE: "fixedIp",

  // ---------------------------- PDF Report ----------------------------
  CONFORM: "conform",
  NON_CONFORM: "nonConform",
  CONFORM_W_RESTRICTION: "conformRestriction",

  TS_MONITOR_VERSION: "1.2.0",

  LABELS_FONT_SIZE: "14px",
  LIVE_LIST_ELEMENTS_PER_PAGE: 25,
  RANDOMIZER_CONSTANT: 234567,

  MAX_NUM_OF_LOG_EVENTS: 200,
  DIAGNOSTIC_LOG_EVENT_TYPE: "diagnostic",
  RETRIES_LOG_EVENT_TYPE: "retries",
  FAULTS_LOG_EVENT_TYPE: "fault",
  ERROR_FRAME_LOG_EVENT_TYPE: "errorFrame",
  MONITOR_INIT_LOG_EVENT_TYPE: "inicializacao",
  OK_EVENT_TYPE: "ok",

  // ###################################################################
  // ########################### PROTOCOL ##############################
  // ###################################################################

  //  ---------------------------- Device Status ----------------------------
  OK: "ok",
  DIAGNOSTIC: "diag",
  FAULT: "fault",
  ONLINE: "online",
  CONFIG_ERROR: "errorConfig",
  PARAM_ERROR: "errorParam",
  MASTER: "master",
  CRITICAL: "critical",
  BLACKLIST: "blacklist",
  MASTER_FAULT: "masterFault",
  SLAVE_MASTER_FAULT: "slaveMasterFault",
  MISSING: "missing",
  MPI: "mpi",
  MPI_FAULT: "mpiFault",

  // ---------------------------- GRAPHIC TOPOLOGY ----------------------------
  MASTER_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/master-fault.png`,
  MASTER_IMG_PATH: `${process.env.PUBLIC_URL}/images/master.png`,
  MASTER_OTHER_IMG_PATH: `${process.env.PUBLIC_URL}/images/master-other.png`,
  HUB_IMG_PATH: `${process.env.PUBLIC_URL}/images/hub.png`,
  JB_IMG_PATH: `${process.env.PUBLIC_URL}/images/junction-box.png`,
  FIBER_LINK_IMG_PATH: `${process.env.PUBLIC_URL}/images/fiber-link.png`,
  ACTIVE_TERMINATION_IMG_PATH: `${process.env.PUBLIC_URL}/images/active-termination.png`,
  TS_MONITOR_IMG_PATH: `${process.env.PUBLIC_URL}/images/ts-monitor.png`,
  MPI_IMG_PATH: `${process.env.PUBLIC_URL}/images/mpi.png`,
  MPI_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/mpi-fault.png`,

  TS_SCOPE_DP_IMG_PATH: `${process.env.PUBLIC_URL}/images/ts-scope-dp.png`,
  TS_SCOPE_PA_IMG_PATH: `${process.env.PUBLIC_URL}/images/ts-scope-pa.png`,

  SLAVE_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave.png`,
  SLAVE_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-ok.png`,
  SLAVE_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-diagnostic.png`,
  SLAVE_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-fault.png`,
  SLAVE_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-config-error.png`,
  SLAVE_PARAM_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-param-error.png`,
  SLAVE_ONLINE_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-online.png`,
  SLAVE_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-blacklist.png`,
  SLAVE_CRITICAL_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-critical.png`,
  SLAVE_MASTER_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-master-failure.png`,
  SLAVE_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-missing.png`,

  SLAVE_PA_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa.png`,
  SLAVE_PA_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-ok.png`,
  SLAVE_PA_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-diagnostic.png`,
  SLAVE_PA_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-fault.png`,
  SLAVE_PA_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-config-error.png`,
  SLAVE_PA_PARAM_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-param-error.png`,
  SLAVE_PA_ONLINE_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-online.png`,
  SLAVE_PA_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-blacklist.png`,
  SLAVE_PA_CRITICAL_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-critical.png`,
  SLAVE_PA_MASTER_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-master-failure.png`,
  SLAVE_PA_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/slave-pa-missing.png`,

  REPEATER_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater.png`,
  REPEATER_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-ok.png`,
  REPEATER_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-diagnostic.png`,
  REPEATER_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-fault.png`,
  REPEATER_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-config-error.png`,
  REPEATER_PARAM_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-param-error.png`,
  REPEATER_ONLINE_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-online.png`,
  REPEATER_BLACKLIST_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-blacklist.png`,
  REPEATER_CRITICAL_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-critical-slave.png`,
  REPEATER_MASTER_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-master-failure.png`,
  REPEATER_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/repeater-missing.png`,

  COUPLER_PROXY_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy.png`,
  COUPLER_PROXY_OK_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-ok.png`,
  COUPLER_PROXY_DIAGNOSTIC_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-diagnostic.png`,
  COUPLER_PROXY_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-fault.png`,
  COUPLER_PROXY_CONFIG_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-config-error.png`,
  COUPLER_PROXY_PARAM_ERROR_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-param-error.png`,
  COUPLER_PROXY_ONLINE_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-online.png`,
  COUPLER_PROXY_BLACKLIST_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-blacklist.png`,
  COUPLER_PROXY_CRITICAL_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-critical-slave.png`,
  COUPLER_PROXY_MASTER_FAULT_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-master-failure.png`,
  COUPLER_PROXY_MISSING_IMG_PATH: `${process.env.PUBLIC_URL}/images/coupler-proxy-missing.png`,

  PROFIBUS_DP_COLOR_TYPE: "dp-standard",
  PROFIBUS_DP_IS_COLOR_TYPE: "dp-hazardous",
  PROFIBUS_MBP_PA_NON_HAZ_COLOR_TYPE: "pa-standard",
  PROFIBUS_MBP_PA_HAZ_COLOR_TYPE: "pa-hazardous",
  PROFIBUS_OPTIC_FIBER_COLOR_TYPE: "optic-fiber",

  // ###################################################################
  // ########################### ANALYZER ##############################
  // ###################################################################

  //  ---------------------------- Device Status Analyzer -------------------
  GOOD: "ok",
  ATTENTION: "attention",
  BAD: "bad",

  // ---------------------------- Oscilloscope ----------------------------
  OSCILLOSCOPE_CHART_ID: "osc-page-chart-id",
  OSCILLOSCOPE_CHART_ID_AB: "osc-page-chart-id-ab",
  BA_CHECKBOX_VAL: "ba-check",
  AB_CHECKBOX_VAL: "ab-check",
  PLAY_REFRESH_INTERVAL_MS: 500,
  AUTO_VISUALIZATION_REFRESH_MS: 1500,
  AUTOMATIC_CHECKBOX_VAL: "auto-check",
  MANUAL_CHECKBOX_VAL: "manual-check",

  // ---------------------------- Bar Graph ----------------------------
  BAR_GRAPH_CHART_ID: "bar-gr-chart-id",

  AMPLITUDE_ID: "amp-id",
  MIN_AMPLITUDE_ID: "min-amp-id",

  CHECKBOX_ADDR_VAL: "check-addr",
  CHECKBOX_ASC_VAL: "check-asc",
  CHECKBOX_DESC_VAL: "check-desc",

  MAX_DEV_PER_PAGE: 15,

  // ------------------- Hexadecimal value of Colors -------------------
  RED_HEX: "#f44336",
  YELLOW_HEX: "#fdd835",
  GREEN_HEX: "#00c853",
  PURPLE_HEX: "#ab47bc",
  TEAL_HEX: "#38C7BD",
  BLUE_HEX: "#003b71",

  FADED_GREEN_HEX: "rgba(0, 200, 83, 0.5)",
  FADED_YELLOW_HEX: "rgba(253, 216, 53, 0.5)",
  FADED_RED_HEX: "rgba(244, 67, 54, 0.5)",

  // ---------------------------- Segment Devices ----------------------------
  IN_SEGMENT: "inSegment",
  POSSIBLY_IN_SEGMENT: "possiblyInSegment",
  NOT_IN_SEGMENT: "notInSegment",

  IN_SEGMENT_LIST: "inSegmentDevices",
  OTHER_LIST: "otherDevices",

});

export default Constants;
